import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { 
  getStatusColor, 
  getRolColor,
  getStatusDescription,
  getRolDescription 
} from '../config/companyFieldsConfig';

// Badge de Estado con tooltip
export const StatusBadge = ({ status }) => {
  if (!status) return null;
  
  const description = getStatusDescription(status);
  const colorClass = getStatusColor(status);
  
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span 
            className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border cursor-help ${colorClass}`}
          >
            {status}
          </span>
        </TooltipTrigger>
        {description && (
          <TooltipContent side="top" className="max-w-xs text-sm">
            <p>{description}</p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};

// Badge de Rol con tooltip
export const RolBadge = ({ rol }) => {
  if (!rol) return null;
  
  const description = getRolDescription(rol);
  const colorClass = getRolColor(rol);
  
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span 
            className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border cursor-help ${colorClass}`}
          >
            {rol}
          </span>
        </TooltipTrigger>
        {description && (
          <TooltipContent side="top" className="max-w-xs text-sm">
            <p>{description}</p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};

export default { StatusBadge, RolBadge };
